import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { PrintersApiAdapter } from '../adapters/PrintersApiAdapter';
import { Printer } from '../models/Printers';

interface UseActivePrintersOptions {
  enabled?: boolean;
}

// 🎯 Hook específico para el desplegable del menú (solo impresoras activas)
export const useActivePrinters = (options: UseActivePrintersOptions = {}) => {
  const { enabled = true } = options;
  const httpClient = createHttpClient(apiClientWH);
  const apiAdapter = new PrintersApiAdapter(httpClient);

  // 🎯 Hook para obtener impresoras activas

  const {
    data: printers,
    isLoading,
    error,
    refetch,
  } = useQuery<Printer[]>({
    queryKey: ['activePrinters'], // 🎯 QueryKey diferente para evitar conflictos
    queryFn: () => apiAdapter.getActivePrinters(),
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000, // 10 minutos
    enabled,
  });

  const memoizedPrinters = useMemo(() => printers || [], [printers]);

  return {
    printers: memoizedPrinters,
    isLoading,
    error: error?.message || null,
    refetch,
  };
};
